<public-account-shell
  [heading]="'account.register.title' | transloco"
  [subheading]="'account.register.subtitle' | transloco"
>
  @if (registrationCompleted()) {
    <div class="register-success" role="status">
      <i class="fa-solid fa-envelope-circle-check register-success__icon" aria-hidden="true"></i>
      <h2 class="register-success__title">{{ 'account.register.checkMailbox.title' | transloco }}</h2>
      <p class="register-success__text">
        {{ 'account.register.checkMailbox.text' | transloco: { email: email() } }}
      </p>
      @if (resendCompleted()) {
        <p class="register-success__resent" role="status">
          {{ 'account.register.checkMailbox.resent' | transloco }}
        </p>
      } @else {
        <button
          eBtn
          color="highlight"
          type="button"
          [loading]="isResending()"
          (click)="onResendVerification()"
        >
          {{ 'account.register.checkMailbox.resend' | transloco }}
        </button>
      }
      <a routerLink="/login" class="register-form__link">{{ 'account.register.backToLogin' | transloco }}</a>
    </div>
  } @else {
    <form class="register-form" (ngSubmit)="onSubmit()">
      @if (codeIsRequired()) {
        <p class="register-form__closed-note" role="note">
          {{ 'account.register.closedNote' | transloco }}
        </p>
      }

      <div class="register-form__row">
        <div class="register-form__field">
          <label class="register-form__label" for="firstName">{{ 'account.register.firstName' | transloco }}</label>
          <input
            id="firstName"
            name="firstName"
            class="register-form__input"
            [ngModel]="firstName()"
            (ngModelChange)="firstName.set($event)"
            autocomplete="given-name"
            required
          />
        </div>
        <div class="register-form__field">
          <label class="register-form__label" for="lastName">{{ 'account.register.lastName' | transloco }}</label>
          <input
            id="lastName"
            name="lastName"
            class="register-form__input"
            [ngModel]="lastName()"
            (ngModelChange)="lastName.set($event)"
            autocomplete="family-name"
            required
          />
        </div>
      </div>

      <div class="register-form__field">
        <label class="register-form__label" for="email">{{ 'account.register.email' | transloco }}</label>
        <input
          id="email"
          name="email"
          type="email"
          class="register-form__input"
          [class.register-form__input--invalid]="email() && !emailIsValid()"
          [ngModel]="email()"
          (ngModelChange)="email.set($event)"
          autocomplete="email"
          required
        />
        @if (email() && !emailIsValid()) {
          <span class="register-form__error">{{ 'account.register.errors.emailInvalid' | transloco }}</span>
        }
      </div>

      <div class="register-form__field">
        <label class="register-form__label" for="password">{{ 'account.register.password' | transloco }}</label>
        <input
          id="password"
          name="password"
          type="password"
          class="register-form__input"
          [ngModel]="password()"
          (ngModelChange)="password.set($event)"
          autocomplete="new-password"
          [attr.aria-describedby]="'password-requirements'"
          required
        />
        <password-strength-meter [password]="password()" />
        <span id="password-requirements" class="register-form__hint">
          {{ 'account.register.passwordRequirements' | transloco: { minLength: minimumPasswordLength } }}
        </span>
      </div>

      <div class="register-form__field">
        <label class="register-form__label" for="confirmPassword">
          {{ 'account.register.confirmPassword' | transloco }}
        </label>
        <input
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          class="register-form__input"
          [class.register-form__input--invalid]="!passwordsMatch()"
          [ngModel]="confirmPassword()"
          (ngModelChange)="confirmPassword.set($event)"
          autocomplete="new-password"
          required
        />
        @if (!passwordsMatch()) {
          <span class="register-form__error">{{ 'account.register.errors.passwordsDoNotMatch' | transloco }}</span>
        }
      </div>

      <div class="register-form__field">
        <label class="register-form__label" for="registrationCode">
          {{ (codeIsRequired() ? 'account.register.codeRequired' : 'account.register.codeOptional') | transloco }}
        </label>
        <input
          id="registrationCode"
          name="registrationCode"
          class="register-form__input"
          [ngModel]="registrationCode()"
          (ngModelChange)="registrationCode.set($event)"
          autocomplete="off"
          [required]="codeIsRequired()"
        />
      </div>

      <label class="register-form__terms">
        <input
          type="checkbox"
          name="acceptedTerms"
          [ngModel]="acceptedTerms()"
          (ngModelChange)="acceptedTerms.set($event)"
          required
        />
        <span>
          {{ 'account.register.acceptTermsPrefix' | transloco }}
          <a routerLink="/terms" target="_blank">{{ 'account.register.termsLink' | transloco }}</a>
          {{ 'account.register.acceptTermsInfix' | transloco }}
          <a [href]="privacyUrl()" target="_blank" rel="noopener">{{ 'account.register.privacyLink' | transloco }}</a>
        </span>
      </label>

      @if (errorKey()) {
        <p class="register-form__error register-form__error--summary" role="alert">
          @if (errorTitleKey()) {
            <strong>{{ errorTitleKey() | transloco }}</strong><br />
          }
          {{ errorKey() | transloco }}
        </p>
      }

      <button eBtn block color="primary" type="submit" [disabled]="!canSubmit()" [loading]="isSubmitting()">
        {{ 'account.register.submit' | transloco }}
      </button>

      <p class="register-form__footer">
        {{ 'account.register.alreadyHaveAccount' | transloco }}
        <a routerLink="/login" class="register-form__link">{{ 'account.register.toLogin' | transloco }}</a>
      </p>
    </form>
  }
</public-account-shell>
